import { render, staticRenderFns } from "./Fa.vue?vue&type=template&id=4777c281&scoped=true"
import script from "./Fa.vue?vue&type=script&lang=js"
export * from "./Fa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4777c281",
  null
  
)

export default component.exports